<template>
  <div :class="containerClass">
    <AppTopBar />
    <div class="layout-main-container">
      <Toast />
      <div class="layout-main">
        <!--
          Keyed on the path so a route that reuses its component still remounts — the lesson
          editor serves both /lesson/create and /lesson/:id, and without this it stayed in create
          mode after the redirect. The query is deliberately excluded: the SG Library tabs live
          in ?tab= and must not remount the page on every switch.
        -->
        <router-view :key="$route.path" />
      </div>
    </div>
  </div>
</template>

<script>
import AppTopBar from "./shared/layout/AppTopbar.vue";
export default {
  components: { AppTopBar },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "p-input-filled": this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled": this.$primevue.config.ripple === false,
          "layout-theme-light": this.$appState.theme.startsWith("saga"),
        },
      ];
    },
  },
  created() {
    // Stale toasts are cleared as a navigation STARTS, not once the new route has landed.
    //
    // Watching $route fired after the route object had already been assigned, so a message
    // raised deliberately FOR the destination — a save that redirects, say — was wiped a tick
    // after it appeared. Three separate bugs came from that single line. A beforeEach guard
    // clears the same stale toasts while still letting the destination speak, and it does not
    // run at all when a component's own beforeRouteLeave blocks the navigation, so an aborted
    // "discard changes?" no longer silently eats whatever was on screen.
    this.stopClearingToasts = this.$router.beforeEach(() => {
      this.$toast.removeAllGroups();
    });
  },
  beforeUnmount() {
    this.stopClearingToasts?.();
  },
};
</script>
